import React from "react";
import { ReactComponent as UploadIcon } from '../../components/Common/BootstrapIcons/upload.svg';
import { ReactComponent as RemoveIcon } from '../../components/Common/BootstrapIcons/close.svg';
import ColumnDefinition from "../../infrastructure/types/DataGrid/ColumnDefinition";
import FileWithDetails from "../../infrastructure/types/common/FileWithDetails";
import BusinessAnalysisField from "../../types/businessAnalysis/BusinessAnalysisField";
import CustomIcon from "../Common/BootstrapIcons/Custom/CustomIcon";
import iconTooltip from "../Common/BootstrapIcons/Tooltip/IconTooltip";
import DeletableItem from "../Common/DeletableItem/DeletableItem";
import EditableText from "../Common/EditableText/EditableText";


const uniqueName = 'business-analysis-home-grid';

const getColumns = (
    onNameChange: (value: string, fieldNumber: number) => void,
    onDescriptionChange: (value: string, fieldNumber: number) => void,
    onCommentChange: (value: string, fieldNumber: number) => void,
    onUploadClick: (fieldNumber: number) => void,
    onRemoveClick: (field: BusinessAnalysisField) => void,
    onRemoveFileClick: (fileWithDetails: FileWithDetails, field: BusinessAnalysisField) => void
): ColumnDefinition<BusinessAnalysisField>[] => {

    return [
        {
            header: 'Reference',
            sortKey: 'Number',
            getContent: x => x.number.toString(),
            width: '8%',
            className:'vertical-align-top'
        },
        {
            header: 'Name',
            sortKey: 'Name',
            getContent: x => <EditableText className='height-100-percents no-resize min-height-200px' onChange={(value: string) => onNameChange(value, x.number)}
                value={x.name}
                multiline={true} disabled={false} />,
            width: '20%',
            className:'vertical-align-top'
        },
        {
            header: 'Description',
            sortKey: 'Description',
            getContent: x => <EditableText className='height-100-percents no-resize min-height-200px' onChange={(value: string) => onDescriptionChange(value, x.number)}
                value={x.description}
                multiline={true} disabled={false} />,
            width: '20%',
            className:'vertical-align-top'
        },
        {
            header: ' Business Comments',
            sortKey: 'Comment',
            getContent: x => <EditableText className='height-100-percents no-resize min-height-200px' onChange={(value: string) => onCommentChange(value, x.number)}
                value={x.comment}
                multiline={true} disabled={false} />,
            width: '20%',
            className:'vertical-align-top'
        },
        {
            header: 'Attachments',
            sortKey: 'Attachments',
            getContent: x => <div className=' height-100-percents display-flex min-height-200px'>
                <button
                    className="custom-icon-button display-flex"
                    onClick={() => onUploadClick(x.number)}
                    disabled={false}>
                    <CustomIcon icon={UploadIcon} title={iconTooltip.upload} />
                </button>
                <DeletableItem
                    items={x.files || []}
                    values={x.files?.map(x => x.number.toString()) || []}
                    buildItem={(item: FileWithDetails) => <span className='break-word'>{`${item.name}.${item.extension}`}</span>}
                    getItemValue={(item: FileWithDetails) => item.number.toString()}
                    onRemoveClick={(item: FileWithDetails) => onRemoveFileClick(item, x)}
                    isRemoveDisabled={(item) => false}
                />
            </div>,
            className: 'vertical-align-top break-all height-100-percents',
            width: '27%'
        },
        {
            header: 'Actions',
            getContent: x =>
                <button
                    className="custom-icon-button"
                    onClick={() => onRemoveClick(x)}>
                    <CustomIcon icon={RemoveIcon} title={iconTooltip.remove} />
                </button>,
            className: 'vertical-align-top text-align-center',
            width: '5%'
        }
    ];
};

const getSuperAdminColumns = (
    onNameChange: (value: string, fieldNumber: number) => void,
    onDescriptionChange: (value: string, fieldNumber: number) => void,
    onRemoveClick: (field: BusinessAnalysisField) => void
): ColumnDefinition<BusinessAnalysisField>[] => {

    return [
        {
            header: 'Reference',
            sortKey: 'Number',
            getContent: x => x.number.toString(),
            width: '10%'
        },
        {
            header: 'Name',
            sortKey: 'Name',
            getContent: x => <EditableText onChange={(value: string) => onNameChange(value, x.number)}
                value={x.name}
                multiline={true} disabled={false} />,
            className: 'break-all',
            width: '45%'
        },
        {
            header: 'Description',
            sortKey: 'Description',
            getContent: x => <EditableText onChange={(value: string) => onDescriptionChange(value, x.number)}
                value={x.description}
                multiline={true} disabled={false} />,
            className: 'break-all',
            width: '45%'
        },
        {
            header: 'Actions',
            getContent: x =>
                <button
                    className="custom-icon-button"
                    onClick={() => onRemoveClick(x)}>
                    <CustomIcon icon={RemoveIcon} title={iconTooltip.remove} />
                </button>,
            className: 'display-flex',
            width: '6%'
        }
    ];
};

export { getColumns, uniqueName, getSuperAdminColumns };